import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

export type IntegrationActionErrorsData = {
  results: {
    created: string;
    referenceId: string;
    cause: string | null;
    errorMessage: string | null;
  }[];
  count: number;
  next: string | null;
  previous: string | null;
};

export type IntegrationActionErrorsParams = {
  integrationActionUuid: string;
  page: number;
  pageSize: number;
};

export type ListIntegrationActionErrorsQueryKey = readonly [
  'managed_integrations',
  'integration_actions',
  IntegrationActionErrorsParams,
  'errors',
];

const getListIntegrationActionErrorsQueryKey = (
  params: IntegrationActionErrorsParams,
): ListIntegrationActionErrorsQueryKey => {
  return ['managed_integrations', 'integration_actions', params, 'errors'];
};

export const useListIntegrationActionErrors: QueryFunction<
  IntegrationActionErrorsData,
  [IntegrationActionErrorsParams],
  ListIntegrationActionErrorsQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const { integrationActionUuid, ...query } = params;
  const request = useRequest(requestOptions);

  const urlPath = `/managed_integrations/integration_actions/${integrationActionUuid}/errors`;
  const queryKey = getListIntegrationActionErrorsQueryKey(params);
  return useQuery({
    ...queryOptions,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Fix in PP-24289
    queryKey,
    queryFn: ({ signal }) =>
      request(urlPath, {
        query,
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
